module.exports = __webpack_public_path__ + "img/guide_dir_08.2b449b27.png";